import React, { useRef } from 'react';
import './option-layout.scss';
import pencilSvg from '../../assets/images/pencil-black.svg';
import { useTranslation } from 'react-i18next';

const OptionLayout = ({
	record,
	imageSource,
	title,
	handleSelection,
	setUrlFilteringModal,
	setObjectDetectionModal
}) => {
	const { t } = useTranslation();
	const layoutRef = useRef(null);
	const dependencyIds = Array.isArray(record?.dependency) ? record?.dependency?.map((item) => item) : [];

	const handleLayoutClick = (e) => {
		const source = e.target.tagName;
		if (e.target.parentElement && (source === 'IMG' || source === 'SPAN' || source === 'DIV')) {
			let targetElement = null;
			switch (source) {
				case 'IMG':
				case 'SPAN':
					targetElement = e.target.parentElement;
					break;

				case 'DIV':
					targetElement = e.target;
					break;

				default:
					break;
			}
			layoutRef.current = targetElement;
			targetElement.classList.toggle('layout-border');
			record.isSelected === undefined && (record.isSelected = false);

			if (record?.isSelected !== undefined) {
				const idsToSelect = record.dependency ? [...dependencyIds, record.id] : [record.id];
				handleSelection(idsToSelect, !record.isSelected);
			}
		}
	};

	return (
		<span
			key={record.id}
			className={'layout-item-wrapper'}
			onClick={handleLayoutClick}
		>
			<div
				className={`${'layout-item'} ${record?.isSelected ? 'layout-border' : ''}`}
				title={t(record.description) || record.description}
			>
				<img className={'box-icon-ong'} src={imageSource} alt='' />
				<span>{title}</span>
				{/* {(record.key === 'url_filtering' || record.key === 'object_detection') && (
                    <img
                        className={'edit-item'}
                        src={pencilSvg}
                        alt='pencil-black'
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            record.key === 'url_filtering'
                                ? setUrlFilteringModal(true)
                                : setObjectDetectionModal(true);
                        }}
                    />
                )} */}
			</div>
		</span>
	);
};

export default OptionLayout;
